import { createSlice } from '@reduxjs/toolkit';
import { CarrierDetailStateType } from 'src/types/carrierDetail';

const initialState: CarrierDetailStateType = {
  data: null,
  loading: false,
  deleted: false,
  error: false,
};

export const carrierDetailSlice = createSlice({
  name: 'carrierDetail',
  initialState,
  reducers: {
    getCarrierDetailFetch: (state, action) => {
      state.loading = true;
      state.error = false;
    },
    getCarrierDetailFetchSuccess: (state, action) => {
      state.data = action.payload.data;
      state.loading = false;
    },
    getCarrierDetailFetchFailure: (state, action) => {
      state.data = null;
      state.loading = false;
      state.error = true;
    },
    createCarrierDetailFetch: (state, action) => {
      state.loading = true;
      state.error = false;
    },
    createCarrierDetailFetchSuccess: (state, action) => {
      state.data = action.payload.data;
      state.loading = false;
    },
    createCarrierDetailFetchFailure: (state, action) => {
      state.loading = false;
      state.error = true;
    },
    updateCarrierDetailFetch: (state, action) => {
      state.loading = true;
      state.error = false;
    },
    updateCarrierDetailFetchSuccess: (state, action) => {
      state.data = action.payload.data;
      state.loading = false;
    },
    updateCarrierDetailFetchFailure: (state, action) => {
      state.loading = false;
      state.error = true;
    },
    deleteCarrierDetailFetch: (state, action) => {
      state.loading = true;
      state.error = false;
    },
    deleteCarrierDetailFetchSuccess: (state, action) => {
      state.deleted = true;
      state.loading = false;
    },
    deleteCarrierDetailFetchFailure: (state, action) => {
      state.loading = false;
      state.error = true;
    },
    clearCarrierDetail: () => initialState,
  },
});

export const {
  getCarrierDetailFetch,
  getCarrierDetailFetchSuccess,
  getCarrierDetailFetchFailure,
  createCarrierDetailFetch,
  createCarrierDetailFetchSuccess,
  createCarrierDetailFetchFailure,
  updateCarrierDetailFetch,
  updateCarrierDetailFetchSuccess,
  updateCarrierDetailFetchFailure,
  deleteCarrierDetailFetch,
  deleteCarrierDetailFetchSuccess,
  deleteCarrierDetailFetchFailure,
  clearCarrierDetail,
} = carrierDetailSlice.actions;

export default carrierDetailSlice.reducer;

